import { SERVER_ROUTES } from '@client/routes/components/Router/routes';
import { simulateLinkClick } from '@client/routes/utils/url';

export const useLogoutAction = (): () => void => () => {
  simulateLinkClick(SERVER_ROUTES.logout);
};
